import React, { useEffect, useState } from "react"

import { Row, Col, Card, CardBody, CardTitle, Button, Container } from "reactstrap"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import { CSVLink } from "react-csv";
import "../PublicPromoCode/datatables.scss"
import { MDBDataTable, MDBBtn } from "mdbreact"
import _ from 'lodash'
import { CircularProgress } from "@material-ui/core";

// MomentJS
import moment from 'moment'

const Campaigns = (props) => {
  const [csvRows, setCsvRows] = useState([])
  const [campaignRecords, setCampainRecords] = useState([])
  const [loding, setLoding] = useState(true)

  // const [authToken, setAuthToken] = useState(null);
  // const ForceUpdate = useState()[1].bind(null, {})
  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    if (token !== '') {
      // setAuthToken(token)      
      getCampaigns(token)
    }
    return () => {
    }
  }, [])
  const headers = [
    { label: "Campaign", key: "campaign" },
    { label: "Type", key: "type" },
    { label: "Bundle", key: "bundle" },
    { label: "Amount", key: "discount_amount" },
    // { label: "Payment Method", key: "paymentMethod" },
    { label: "Start Date", key: "stDate" },
    { label: "Expiry Date", key: "expDate" },
    // { label: "No of Codes", key: "noOfCodes" },
    // { label: "Max usage per day", key: "maxPerDay" },
    // { label: "Max usage per campaign", key: "maxPerCampaign" },
    { label: "Minimum Spend", key: "min_spend" },
    { label: "Maximum Discount", key: "max_discount" },
    { label: "Merchant", key: "merchant" },
    // { label: "Category", key: "category" },
    { label: "Product", key: "product" },
    { label: "Minimum Quantity", key: "min_quantity" },
  ];
  const csvData = []

  const campaigns = {
    columns: [
      {
        label: "Campaign",
        field: "campaign",
        sort: "asc",
        width: 150,
      },
      {
        label: "Type",
        field: "type",
        sort: "asc",
        width: 270,
      },
      {
        label: "Merchant",
        field: "merchant",
        sort: "asc",
        width: 200,
      },
      {
        label: "Usage",
        field: "UsigLimit",
        sort: "asc",
        width: 100,
      },
      {
        label: "Discount Amount",
        field: "discount_amount",
        sort: "asc",
        width: 100,
      },

      // {
      //   label: "Created Date",
      //   field: "created_at",
      //   sort: "desc",
      //   width: 150,
      // },
      {
        label: "Start Date",
        field: "stDate",
        sort: "asc",
        width: 150,
      },

      {
        label: "Expiry Date",
        field: "expDate",
        sort: "asc",
        width: 100,
      },

      {
        label: "Status",
        field: "startPauseBtn",
        sort: "asc",
        width: 100,
      },

      // {
      //   // label: "Status",
      //   field: "updateBtn",
      //   sort: "asc",
      //   width: 100,
      // },
    ],
    rows: []
  }

  const getCampaigns = async (token) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns?pageSize=-1`, requestOptions)
      .then(response => response.text())
      .then(result => {
        let _data = JSON.parse(result)
        console.log("Campaign Data===>", _data)

        let Result = _.sortBy(_data, 'created_at')
        Result.reverse()
        setLoding(false)

        Result && Result.map((item) => {
          let stringArr = []
          let stringArr2 = []
          let stringArr3 = []
          if (item.discount_merchants) {
            let tempArr = JSON.parse(item.discount_merchants)
            for (var index in tempArr) {
              if (tempArr[index]?.label) {
                stringArr.push(tempArr[index].label)
              }
            }
          }
          if (item.discount_categories) {
            let tempArr = JSON.parse(item.discount_categories)
            for (var index in tempArr) {
              if (tempArr[index]?.label) {
                stringArr2.push(tempArr[index].label + ", ")
              }
            }
          }
          if (item.discount_products) {
            let tempArr = JSON.parse(item.discount_products)
            for (var index in tempArr) {
              if (tempArr[index]?.label) {
                stringArr3.push(tempArr[index].label + ", ")
              }
            }
          }

          let campaignRow = {
            campaign: item.name,
            type: item.discount_type ? item.discount_type : "NA",
            created_at: item.created_at ? moment(item.created_at).format('MM Do ,YYYY, h:mm a') : "NA",
            maxPerCampaign: item.max_limit_per_user == -1 ? "No Limit" : item.max_limit_per_user,
            maxPerDay: item.max_limit_per_day == -1 ? "No Limit" : item.max_limit_per_day,
            UsigLimit: item?.promo_redeemed_count,
            stDate: item.start_date ? moment(item.start_date).format('MMMM Do, YYYY') : "NA",
            expDate: item.end_date ? moment(item.end_date).format('MMMM Do, YYYY') : "NA",
            discount_amount: item.discount_amount ? item.discount_type == "amount" ? `$${item.discount_amount}` : `${item.discount_amount}%` : "NA",

            merchant: stringArr.length > 0 ? stringArr : (item.discount_merchants ? JSON.parse(item.discount_merchants) : "Any Merchant"),
            category: stringArr2.length > 0 ? stringArr2 : (item.discount_categories ? JSON.parse(item.discount_categories) : "Any Category"),

            // codesBtn: <MDBBtn color="dark" outline size="md" onClick={()=>{tableButtonClick(item.id)}}>abc</MDBBtn>,
            startPauseBtn: <select className="p-1 px-2 text-white bg-dark btn"
              id="demo-simple-helper"
              defaultValue={item?.status}
              onChange={(e) => StartPauseClick(item, e.target.value)}>
              <option value="active">Active</option>
              <option value="paused">Paused</option>
            </select>
          }

          let csvRow = {
            campaign: item.name, type: item?.discount_type,
            bundle: item.bundle ? item.bundle : "NA",
            discount_amount: item.discount_amount ? item.discount_type == "amount" ? `$${item.discount_amount}` : `${item.discount_amount}%` : "NA",
            // paymentMethod: item.payment_method ? item.paymentMethod : "NA",
            stDate: item.start_date ? moment(item.start_date).format('MMMM Do, YYYY') : "NA",
            expDate: item.end_date ? moment(item.end_date).format('MMMM Do, YYYY') : "NA",
            // noOfCodes: item.max_promocodes_allocated == -1 ? "No Limit" : item.max_promocodes_allocated,
            // maxPerDay: item.max_limit_per_day == -1 ? "No Limit" : item.max_limit_per_day,
            // maxPerCampaign: item.max_limit_per_user == -1 ? "No Limit" : item.max_limit_per_user,
            min_spend: item.min_spend ? item.min_spend : "NA",
            max_discount: item.discount_type == "percent" ? item.max_discount : "NA",
            merchant: stringArr.length > 0 ? stringArr : (item.discount_merchants ? JSON.parse(item.discount_merchants) : "Any Merchant"),
            // category: stringArr2.length > 0 ? stringArr2 : (item.discount_categories ? JSON.parse(item.discount_categories) : "Any Category"),
            product: stringArr3.length > 0 ? stringArr3 : (item.discount_products ? JSON.parse(item.discount_products) : "Any Product"),
            min_quantity: item.min_quantity ? item.min_quantity : "NA"
          }
          campaigns.rows = [...campaigns.rows, campaignRow]
          csvData.push(csvRow)
        })
        setCampainRecords(campaigns)
        setCsvRows(csvData)
      })
      .catch(error => alert('error', error));
  }
  const updateButtonClick = (cat_ID1) => {
    props.history.push(`/update-campaign/${cat_ID1}`, {
      cat_ID: cat_ID1
    })
  }
  const tableButtonClick = (cat_ID1) => {
    // `/user/${index + 1}`
    props.history.push(`/promo-codes/${cat_ID1}`, {
      cat_ID: cat_ID1
    })
  }

  const StartPauseClick = async (item, value) => {
    // console.log("Item came here:  ", item, " ", value)
    if (item.status == value)
      return

    var urlencoded = new URLSearchParams();
    // urlencoded.append("marketplace_id", "6a125896-1fe8-4fb0-9e13-8f45f1131d44");
    urlencoded.append("id", item.id);
    urlencoded.append("status", item.status == "active" ? "paused" : "active");
    // let body = {
    //   id: item.id,
    //   status: "paused"
    // }

    let token = localStorage.getItem("AuthenticationToken")
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
      method: 'PUT',
      body: urlencoded,
      headers: myHeaders,
    };

    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns/update`, requestOptions)
      .then(response => {
        if (response.status == 200) {
          // getCampaigns()
          window.location.reload(true);
        }
      })
      .catch((err) => {
        // console.log("error occured")
      })

  }


  const csvReport = {
    data: csvRows,
    headers: headers,
    filename: 'Campaigns_data.csv'
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          {/* <Breadcrumbs title="Tables" breadcrumbItem="Responsive Table" /> */}

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={3} style={{ textAlign: "left" }}>
                      <CardTitle className="h4">Campaigns</CardTitle>
                    </Col>
                    <Col lg={6}></Col>
                    {/* <Col lg={2} style={{ textAlign: "right"}}>
                            <Button outline color="secondary" size='md'
                            onClick={()=>{
                                props.history.push("/create-campaign")
                            }}
                            >Create Campaign</Button>
                        </Col> */}
                    <Col lg={1} style={{ flexDirection: "row", textAlign: "left" }}>
                      <Container lg={2}>
                        <CSVLink style={{ flexDirection: "column", flex: 1 }} {...csvReport}>
                          <i className="uil-file-download-alt" style={{ fontSize: 26, alignSelf: "right", color: "black" }} />
                        </CSVLink>
                      </Container>
                    </Col>
                  </Row>
                  <div style={{ marginBottom: 50 }}></div>
                  {loding ?
                    <div>
                      <div role="status" style={{ textAlign: "center" }}>
                        <CircularProgress
                          size={50} value={100} color={"black"}
                        />
                      </div>

                    </div> :
                    <div>
                      <MDBDataTable responsive bordered data={campaignRecords} order={['Start date', 'desc']} />
                    </div>
                  }
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Campaigns;
